import{s as e}from"./style-inject.es-a0e1a0ba.js";var r=".mbeHR{display:block;width:100%}",s={giphy_player:"mbeHR"};e(r);export{s as n};
//# sourceMappingURL=giphy-viewer-9c024124.js.map
